var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{directives:[{name:"debounce",rawName:"v-debounce:500ms",value:((v) => _vm.updateProp(v)),expression:"(v) => updateProp(v)",arg:"500ms"}],staticClass:"parameter-textarea",attrs:{"placeholder":_vm.placeholderValue},domProps:{"value":_vm.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }